// :::: SIZES
export const mobile =  767;
export const tablet = 992;
export const desktop =  1250;
export const maxDesktop = 1420;
export const mapDeskHeight = 756;

// :::: COLORS
export const baseTitle49 = '#494128';
export const baseText81 = '#818181';
// this may change
export const baseOcra = '#E2AB59';
export const galleryBackground = '#000000';

// :::: Z-INDEXES
export const overMap = 10000;
